module.exports = __webpack_public_path__ + "img/max-envelope-transfer.96164329.svg";